import React from "react";
import InvoiceDetailsDefaultView from "./InvoiceDetailsDefaultView";
import InvoiceDetailsPrintView from "./InvoiceDetailsPrintView";
interface InvoiceDetailsProps {
  contentRef: React.RefObject<HTMLDivElement>;
}
const InvoiceDetails: React.FC<InvoiceDetailsProps> = ({ contentRef }) => {
  return (
    <div ref={contentRef}>
      <InvoiceDetailsDefaultView />
      <InvoiceDetailsPrintView contentRef={contentRef} />
    </div>
  );
};

export default InvoiceDetails;
